import { render, staticRenderFns } from "./ItineraryPricesMatrix.vue?vue&type=template&id=1d9b5677&"
import script from "./ItineraryPricesMatrix.vue?vue&type=script&lang=js&"
export * from "./ItineraryPricesMatrix.vue?vue&type=script&lang=js&"
import style0 from "./ItineraryPricesMatrix.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports